// extracted by mini-css-extract-plugin
export default {"cartItemQuantity":"cartItemQuantity__NzRiY","smaller":"smaller__MzNjM"};